import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const CertifiedDiamondsPage = () => {
  const diamonds = [
    { name: 'Round Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/ROUND.png' },
    { name: 'Heart Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/Heart-1.png' },
    { name: 'Emerald Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/Emerald-1.png' },
    { name: 'Marquise Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/08/Marquise.png' },
    { name: 'Pear Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/pear.png' },
    { name: 'Princess Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/Princess.png' },
    { name: 'Cushion Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/Cushion.png' },
    { name: 'Asscher Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/ASSCHER.png' },
    { name: 'Oval Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/OVAL.png' },
    { name: 'Radiant Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/Radiant.png' },
    { name: 'Calf Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/08/Calf.png' },
    { name: 'Trilliant Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/08/Trillion.png' },
    { name: 'Shield Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/08/Shield.png' },
    { name: 'Lozenge Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/08/Lozenge.png' },
    { name: 'Half Moon Cut Diamond', image: 'https://gurudiam.com/wp-content/uploads/2024/07/matching5.png' },
  ];

  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <Navbar />

      {/* Hero Section */}
      <section className="section-padding bg-[var(--accent-green-dark)] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="hero-large mb-6" style={{ color: 'white' }}>Certified Diamonds</h1>
            <p className="body-large mb-8" style={{ color: 'white' }}>
              Explore our exclusive range of diamonds, each meticulously crafted to perfection. From classic solitaires to breathtaking designs, we offer a stunning selection that embodies the essence of luxury.
            </p>
            <div className="flex gap-4 justify-center">
              <Link to="/contact" className="btn-primary" style={{ borderColor: 'white', color: 'white' }}>
                <span className="button-text">SCHEDULE A CALL</span>
              </Link>
              <Link to="/contact" className="btn-primary" style={{ borderColor: 'white', color: 'white' }}>
                <span className="button-text">ACCESS INVENTORY</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Diamonds Grid */}
      <section className="section-padding">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="hero-medium mb-4">Certified Diamonds</h2>
            <p className="body-large">Verified Brilliance, Quality Assured Elegance.</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {diamonds.map((diamond, index) => (
              <div key={index} className="text-center group cursor-pointer">
                <div className="bg-[var(--bg-secondary)] p-6 mb-4 transition-all hover:bg-[var(--accent-green-pale)] hover:shadow-lg">
                  <img
                    src={diamond.image}
                    alt={diamond.name}
                    className="w-full h-32 object-contain transition-transform group-hover:scale-110"
                  />
                </div>
                <h3 className="heading-3">{diamond.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CertifiedDiamondsPage;
